import { GA_MEASUREMENT_ID, GOOGLE_ADS_ID, META_PIXEL_ID } from '../config/env.js';

export const CONSENT_KEY = 'rk-cookie-consent';

let analyticsLoaded = false;

export function getAnalyticsConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === 'accepted' || value === '1') return 'accepted';
    if (value === 'rejected') return 'rejected';
    return null;
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(choice) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(CONSENT_KEY, choice);
  } catch {
    /* ignore */
  }
  if (choice === 'accepted') loadAnalytics();
}

function loadGtag() {
  if (!GA_MEASUREMENT_ID || typeof window.gtag === 'function') return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: true });
  if (GOOGLE_ADS_ID) gtag('config', GOOGLE_ADS_ID);
}

function loadFbq() {
  if (!META_PIXEL_ID || typeof window.fbq === 'function') return;

  const n = (window.fbq = function fbq() {
    if (n.callMethod) n.callMethod.apply(n, arguments);
    else n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(script, first);

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

export function loadAnalytics() {
  if (typeof window === 'undefined' || analyticsLoaded) return;
  if (getAnalyticsConsent() !== 'accepted') return;
  loadGtag();
  loadFbq();
  analyticsLoaded = true;
}

export function initAnalytics() {
  loadAnalytics();
}

export function trackEvent(name, params = {}) {
  if (getAnalyticsConsent() !== 'accepted') return;
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, params);
  }
}

export function shareSiteOnWhatsApp(message, url) {
  const base = (url || window.location.origin || 'https://repatikosam.com').replace(/\/$/, '');
  const shareUrl = `${base}/?utm_source=whatsapp&utm_medium=social&utm_campaign=reader_share`;
  const text = `${message}\n${shareUrl}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
}
